import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SalonManagementContactMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.manage.contact(0));
  };

  return (
    <MainMenuItem
      itemTitleString="連絡する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SalonManagementContactMenuItem;
